import { TaskStatus } from '../../../domain/types';
import { FiltersMapper } from '../../../hooks/use-filters/useFilters';
import { TaskSerpPageFilterOption, TaskSerpPageFilters } from './types';

export const LOAD_SERP_TASKS_ERROR_MESSAGE = 'Non è stato possibile recuperare le attività.';
export const NO_SERP_TASKS = 'Non sono presenti attività.';

export const ALL_TASKS_FILTER_OPTION: TaskSerpPageFilterOption = {
  key: 'all',
  label: {
    short: 'Tutte',
    long: 'Tutte le attività',
  },
  value: {},
};

export const STATUS_FILTERS: TaskSerpPageFilterOption[] = [
  {
    key: 'todo',
    label: {
      short: 'Da fare',
      long: 'Attività da fare',
    },
    value: {
      status: TaskStatus.TODO,
    },
  },
  {
    key: 'inProgress',
    label: {
      short: 'In corso',
      long: 'Attività in corso',
    },
    value: {
      status: TaskStatus.IN_PROGRESS,
    },
  },
  {
    key: 'done',
    label: {
      short: 'Completate',
      long: 'Attività completate',
    },
    value: {
      status: TaskStatus.DONE,
    },
  },
];

export const FILTER_OPTIONS: TaskSerpPageFilterOption[] = [
  ...STATUS_FILTERS,
  ALL_TASKS_FILTER_OPTION,
];

export const GROUPED_FILTER_OPTIONS = [
  {
    label: 'Stato',
    options: STATUS_FILTERS,
  },
];

export const FILTERS_MAPPER: FiltersMapper<TaskSerpPageFilters> = {
  filter: (v) => FILTER_OPTIONS.find(({
    key,
  }) => key === v)?.key || ALL_TASKS_FILTER_OPTION.key,
};
